import { TagCloud } from 'react-tagcloud'
import React from 'react'
// import data from '../../data/wordcloud_keyword.json';
import { SubAccount, ClientsAPI } from 'src/api'

const options = {
    luminosity: 'light',
    hue: 'blue',
}

type Props = {
    client?: SubAccount
}
class KeyCloud extends React.Component<Props> {
    state = {
        data: undefined,
        // narrative: undefined
    }
    fetchData = (client: SubAccount) => {
        // const params = {
        //   narrative_assembly_id: "3870d92a-e82c-11ea-86cf-0e95a518f8f7",
        //   report_content_id: "16ce3654-efc5-11ea-86cf-0e95a518f8f7",
        //   sub_account_id: client.id,
        //   period_index: "1449",
        //   period_type: "monthly"
        // }

        ClientsAPI.getReportData(client, 'wordcloud_keyword.json').then(result => {
            // console.log('done', result)
            this.setState({ data: result.data });
        }).catch(error => {
            // console.log('error', error)
        })

        // ClientsAPI.getNarrative(client, params).then(result => {
        //   // console.log('done', result)
        //   this.setState({ narrative: result[0] });
        // }).catch(error => {ß
        //   // console.log('error', error)
        // })
    }
    render() {
        const { data } = this.state
        const { client } = this.props;
        if (!data && client) {
            this.fetchData(client);
        }

        if (!data) return null;

        return (
            <TagCloud
                style={{ height: 200, width: '90%' }}
                minSize={12}
                maxSize={40}
                tags={data}
                colorOptions={options}
                // onClick={(tag: { value: any; }) => alert(`'${tag.value}' was selected!`)}
                title='Keywords by Impressions'
            />
        );
    }
}

export default KeyCloud;



// WEBPACK FOOTER //
// ./src/components/ReportComponents/KeywordCloud.tsx